import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { useAuthStore } from '@/features/auth/store/auth-store';
import { fetchCurrentUser } from '@/lib/auth';
import { Skeleton } from '@/components/ui/skeleton';

export function RequireAuth({ children }: { children?: React.ReactNode }) {
  const { user, status } = useAuth();
  const setUser = useAuthStore((s) => s.setUser);
  const setStatus = useAuthStore((s) => s.setStatus);
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    setStatus('loading');
    fetchCurrentUser()
      .then((u) => {
        if (cancelled) return;
        setUser(u);
      })
      .catch(() => {
        if (cancelled) return;
        setUser(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'loading' || status === 'idle') {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-3 bg-bg">
        <Skeleton className="h-10 w-10 rounded-full" />
        <Skeleton className="h-3 w-32" />
      </div>
    );
  }

  if (status === 'unauthenticated' || !user) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  return <>{children ?? <Outlet />}</>;
}